import isLoginAccountStore from "../store/isLoginAccount";
import loginAccountStore from "../store/isLoginAccount";
import totalNlcStore from "../store/totalNlc";



// Custom hook để sử dụng và cập nhật cấu hình player
const useTotalNlc = () => {
    const totalNlc = totalNlcStore((state) => state.totalNlc);
    const setTotalNlc = totalNlcStore((state) => state.setTotalNlc);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        totalNlc,
        setTotalNlc
    };
};

export default useTotalNlc;
